/**
 * Centralized configuration for all legal pages.
 * Used by LegalNavigation component to generate tabs.
 */
export const LEGAL_PAGES = [
  { 
    id: 'terms', 
    label: 'Terms of Service', 
    path: '/terms', 
    altPaths: ['/terms-of-service'],
    translationKey: 'terms'
  },
  { 
    id: 'privacy', 
    label: 'Privacy Policy', 
    path: '/privacy', 
    altPaths: ['/privacy-policy'],
    translationKey: 'privacy'
  },
  { 
    id: 'dpa', 
    label: 'Data Processing Agreement', 
    path: '/dpa', 
    altPaths: ['/legal/data-processing-agreement'],
    translationKey: 'dpa'
  },
  { 
    id: 'impressum', 
    label: 'Impressum', 
    path: '/impressum',
    translationKey: 'impressum'
  },
  { 
    id: 'disclaimer', 
    label: 'Disclaimer', 
    path: '/disclaimer',
    translationKey: 'disclaimer'
  },
  { 
    id: 'eula', 
    label: 'EULA', 
    path: '/eula',
    translationKey: 'eula'
  },
  { 
    id: 'acceptable-use', 
    label: 'Acceptable Use', 
    path: '/acceptable-use',
    translationKey: 'acceptableuse'
  },
  { 
    id: 'cookies', 
    label: 'Cookie Policy', 
    path: '/cookie-settings',
    translationKey: 'cookies'
  },
  { 
    id: 'gdpr', 
    label: 'GDPR', 
    path: '/gdpr',
    translationKey: 'gdpr'
  }
];

/**
 * Get all possible paths for a legal page (including language prefixes and alt paths)
 */
export const getAllPathsForPage = (page) => {
  const paths = [page.path, ...(page.altPaths || [])];
  // Add language-prefixed versions
  const allPaths = [];
  paths.forEach(path => {
    allPaths.push(path);
    // Add /:lang/ prefix version
    allPaths.push(path.replace(/^\//, '/:lang/'));
  });
  return allPaths;
};

/**
 * Check if current path matches a legal page
 */
export const getCurrentLegalPage = (currentPath) => {
  // Remove hash and query parameters
  const pathWithoutHash = currentPath.split('#')[0].split('?')[0];
  
  // Remove language prefix if present (e.g., /de/legal/... -> /legal/...)
  const normalizedPath = pathWithoutHash.replace(/^\/[a-z]{2}(\/|$)/, '/');
  
  // Try exact match first
  for (const page of LEGAL_PAGES) {
    if (normalizedPath === page.path || 
        normalizedPath === `${page.path}/` ||
        (page.altPaths && page.altPaths.some(alt => normalizedPath === alt || normalizedPath === `${alt}/`))) {
      return page;
    }
  }
  
  // Try startsWith match for nested routes (e.g., /legal/data-processing-agreement matches /legal/data-processing-agreement)
  for (const page of LEGAL_PAGES) {
    if (normalizedPath.startsWith(page.path) || 
        (page.altPaths && page.altPaths.some(alt => normalizedPath.startsWith(alt)))) {
      return page;
    }
  }
  
  return null;
};

